"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getInboxRuleRequest_1 = require("owa-service/lib/factory/getInboxRuleRequest");
var getInboxRuleOperation_1 = require("owa-service/lib/operation/getInboxRuleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Helper method that creates the GetInboxRuleRequest body
 * @return GetInboxRuleRequest
 */
function createRequestBody() {
    return getInboxRuleRequest_1.default({ Header: ServiceRequestUtils_1.getJsonRequestHeader() });
}
/**
 * Get inbox rules service
 * @return the GetInboxRuleResponse
 */
function getInboxRulesService() {
    var requestBody = createRequestBody();
    return getInboxRuleOperation_1.default(requestBody);
}
exports.default = getInboxRulesService;
//# sourceMappingURL=getInboxRulesService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/getInboxRulesService.js
// module id = 5220
// module chunks = 2